<template>
  <el-card
    class="ds-detail"
    style="position: relative; z-index: 0; width: 100%"
  >
    <div slot="header" class="clearfix" v-if="backVisible">
      <el-button @click="$router.back()" class="pull-left">
        <i class="fa fa-chevron-left fa-fw"></i> 返回 </el-button
      >&nbsp;
      <el-tag size="medium">{{ item.Name }}</el-tag>
    </div>
    <el-row :gutter="20">
      <el-col :span="16">
        <div class="border-style">产品信息</div>
        <table
          border="1"
          bordercolor="#dedede"
          style="
            width: 100%;
            border-collapse: collapse;
            font-size: 13px;
            margin-bottom: 15px;
          "
        >
          <tr height="40">
            <th width="15%">产品型号名称</th>
            <td width="35%">
              <div v-if="item.IpcProductModel">
                {{ item.IpcProductModel.Name }}
              </div>
            </td>
            <th width="15%">产品型号</th>
            <td width="35%">
              <div v-if="item.IpcProductModel">
                {{ item.IpcProductModel.Number }}
              </div>
            </td>
          </tr>
          <tr height="40">
            <th>产品SN</th>
            <td>{{ item.SN }}</td>
            <th>入库日期</th>
            <td>
              <div v-if="item.StockinAt">
                {{ $sys.dateFormat(item.StockinAt, "Y-m-d") }}
              </div>
            </td>
          </tr>
          <tr height="40">
            <th>机器码</th>
            <td colspan="3">{{ item.MachineCode }}</td>
          </tr>
          <tr height="40">
            <th>备注</th>
            <td colspan="3">{{ item.Remark }}</td>
          </tr>
          <tr height="40">
            <th>出库日期</th>
            <td v-if="item.StockoutAt">
              {{ $sys.dateFormat(item.StockoutAt, "Y-m-d") }}
            </td>
            <td v-else></td>
            <th>出库单号</th>
            <td>{{ item.CheckoutNo }}</td>
          </tr>
          <tr height="40">
            <th>质保开始日期</th>
            <td v-if="item.QualityStartAt">
              {{ $sys.dateFormat(item.QualityStartAt, "Y-m-d") }}
            </td>
            <td v-else></td>
            <th>质保结束日期</th>
            <td v-if="item.QualityEndAt">
              {{ $sys.dateFormat(item.QualityEndAt, "Y-m-d") }}
            </td>
            <td v-else></td>
          </tr>
          <tr height="40">
            <th>客户名称</th>
            <td v-if="item.Client">
              {{ item.Client.ClientName }}
            </td>
            <td v-else></td>
            <th>出库经办人</th>
            <td>{{ item.Operator }}</td>
          </tr>
          <tr height="40">
            <th>领用人</th>
            <td>{{ item.Recipient }}</td>
            <th>状态</th>
            <td>{{ item.StatusName }}</td>
          </tr>
          <tr height="40">
            <th>出库备注</th>
            <td colspan="3">{{ item.StockoutReason }}</td>
          </tr>
        </table>
        <div
          style="text-align: left; font-size: smaller"
          v-if="item.Attachments && item.Attachments.length > 0"
        >
          <span
            style="padding-left: 10px"
            v-for="attachment in item.Attachments"
            :key="attachment.Url"
          >
            <a
              target="_blank"
              :href="attachment.Url"
              :download="attachment.Name"
              style="color: #409eff"
              >{{ attachment.Name }}</a
            >
          </span>
        </div>
        <div class="border-style">配件列表</div>
        <el-table :data="item.IpcAccessories" v-loading="loading">
          <el-table-column type="index" width="40"></el-table-column>
          <el-table-column prop="IpcAccessoryModel.Name" label="配件名称" />
          <el-table-column
            prop="IpcAccessoryModel.Brand"
            label="品牌"
            width="100"
          />
          <el-table-column
            prop="IpcAccessoryModel.ModelNumber"
            label="型号"
            width="100"
          />
          <el-table-column prop="SN" label="配件SN">
            <template slot-scope="scope">
              <el-tag>
                {{ scope.row.SN }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="8">
        <div class="border-style">日志信息</div>
        <div class="dialogDiv">
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :timestamp="
                $sys.dateFormat(activity.UpdatedAt) + ' ' + activity.Operator
              "
              placement="top"
            >
              <el-card>
                <p style="margin-top: 0px; margin-bottom: 0px">
                  {{ activity.Content }}
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
export default {
  props: ["ID", "showBack"],
  data() {
    return {
      item: {},
      productID: "",
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: -1,
      },
      activities: [], //日志
      backVisible: true,
    };
  },
  mounted() {
    this.init();
    this.getItemData();
    this.getLog();
  },
  methods: {
    init() {
      //直接路由跳转页面
      if (this.$route.params.ID) {
        this.productID = this.$route.params.ID;
      }
      //通过弹框嵌入该页面
      if (this.ID) {
        this.productID = this.ID;
      }
      //通过弹框嵌入该页面，不显示返回按钮和点位名称
      if (this.showBack === false) {
        this.backVisible = false;
      }
    },
    getItemData() {
      this.item = {};
      this.$axios
        .get(`ipc/product/${this.productID}`)
        .then((response) => {
          this.item = response.data;

          if (this.item.Attachments && this.item.Attachments.length > 0) {
            this.item.Attachments.forEach((att) => {
              this.index += 1;
              this.fileList.push({
                uid: this.index,
                name: att.Name,
                url: att.Url,
              });
            });
          }

          if (this.item.IpcProductModel != null) {
            this.currentProductModel = [
              {
                ID: this.item.IpcProductModelID,
                NameNumber: this.item.IpcProductModel.NameNumber,
              },
            ];
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });

      this.getLog();
    },
    getLog() {
      this.$axios
        .get(`ipc/product/${this.productID}/record`, {
          params: {
            ...this.pager,
            order: ["-updated_at", "-id"],
          },
        })
        .then((response) => {
          this.activities = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.ds-detail {
  .el-tabs__header {
    z-index: 0;
  }
  .fix-width {
    width: 120px;
  }
  table th td,
  table tr td {
    padding: 2px 5px;
    height: 30px;
    line-height: 30px;
    table-layout: FIXED;
    word-break: break-all;
  }
  table th {
    text-align: center;
    // padding-left: 5px;
    color: #646566;
    background-color: #ecf5ff;
    font-size: 11px;
  }
  .border-style {
    height: 28px;
    line-height: 28px;
    border-radius: 0 15px 15px 0;
    border-left: 3px solid #409eff;
    padding-left: 5px;
    margin-bottom: 10px;
    background-color: #ecf5ff;
    color: #409eff;
    font-size: 13px;
    font-weight: bolder;
  }
}
</style>
